<template>
  <fragment>
    <div class="mobileoverflow" style="width: 100%;">
      <table class="tablestyle">
        <thead>
          <tr>
            <th>{{ $t('result_page.draw_result_id') }}</th>
            <th style="width: 95px; min-width: 95px; max-width: 95px;">
              {{ $t('datetime') }}
            </th>
            <th>{{ $t('ball_1') }}</th>
            <th>{{ $t('ball_2') }}</th>
            <th>{{ $t('ball_3') }}</th>
            <th class="info-td-o">{{ $t('result_type.BIG_SMALL') }}</th>
            <th class="info-td-o">{{ $t('result_type.ODD_EVEN') }}</th>
            <th class="info-td-o">{{ $t('result_type.RED_BLUE') }}</th>
            <th class="info-td-o">{{ $t('Combo') }}</th>
            <th class="info-td-o">{{ $t('result_type.ROW_1_BET') }}</th>
            <th class="info-td-o">{{ $t('result_type.ROW_3_BET') }}</th>
            <th class="info-td-o">{{ $t('result_type.ROW_5_BET') }}</th>
            <th class="info-td-o">{{ $t('result_type.COLUMN_BET') }}</th>
          </tr>
        </thead>
        <tbody>
          <Pass
            v-for="(column, index) in data"
            :key="index"
            :metadata="getDataDetail(column)"
          >
            <tr
              slot-scope="{ metadata }"
            >
              <td>{{ column.id }}</td>
              <td>{{ column.endAt }} </td>
              <td>{{ metadata.firstBall }} </td>
              <td>{{ metadata.secondBall }} </td>
              <td>{{ metadata.thirdBall }} </td>
              <td><BigSmall :value="metadata.nextBallOverUnder" /></td>
              <td><OddEven :value="metadata.nextBallOddEven" /></td>
              <td><RedBlue :value="metadata.nextBallRedBlack" /></td>
              <td><Combo :value="metadata.nextBallCombo" /></td>
              <td>{{ $t(metadata.row1Ball) }} </td>
              <td>{{ $t(metadata.row3Ball) }} </td>
              <td>{{ $t(metadata.row5Ball) }} </td>
              <td>{{ $t(metadata.columnBall) }} </td>
            </tr>
          </Pass>
        </tbody>
      </table>
    </div>
  </fragment>
</template>

<script>
import { calculateScore } from '@handlers/number/result.js';
import BigSmall from '@components/content/result/big-small.vue';
import OddEven from '@components/content/result/odd-even.vue';
import RedBlue from '@/src/components/content/result/red-blue.vue';
import Combo from '@components/content/result/combo.vue';

const Pass = {
  render() {
    return this.$scopedSlots.default(this.$attrs)
  }
}

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Pass, BigSmall, OddEven, RedBlue, Combo,
  },
  props: {
    id: Number,
    endAt: String,
    data: Array,
  },
  data() {
    return {
      drawtype: '0',
    }
  },
  methods: {
    getDataDetail: function(column){
      if(column.resultRaw === undefined){
        return {};
      }
      const score = calculateScore(column);
      // console.log('score', score);
      return score;
    },
    selectFilter(event) {
      this.drawtype = event;
    },
  }
}
</script>

